import React from 'react';

const Tabs = ({ tabs, activeTab, onTabClick }) => {
  // Define colors for the dots based on common status meanings, can be expanded
  const statusColors = {
    Pending: 'bg-yellow-400',
    Interviewing: 'bg-blue-400',
    "Match Requested": 'bg-purple-400',
    "Offer made": 'bg-green-500',
    Rejected: 'bg-red-500',
    Unsuccessful: 'bg-red-500', // Assuming Unsuccessful is similar to Rejected
    Default: 'bg-gray-400'
  };

  // Function to get the dot color for a tab label
  const getDotColor = (label) => {
    if (label.toLowerCase().includes('pending')) return statusColors.Pending;
    if (label.toLowerCase().includes('interviewing')) return statusColors.Interviewing;
    if (label.toLowerCase().includes('request')) return statusColors["Match Requested"];
    if (label.toLowerCase().includes('offer')) return statusColors["Offer made"];
    if (label.toLowerCase().includes('rejected') || label.toLowerCase().includes('unsuccessful')) return statusColors.Rejected;
    return statusColors.Default;
  };

  return (
    // Main container for the tabs, mimicking the image's white rounded box for tabs
    <div className="bg-white p-1.5 rounded-xl shadow-sm flex flex-wrap gap-1 sm:gap-2 w-full overflow-x-auto no-scrollbar">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onTabClick(tab.value)}
          className={`
            flex-shrink-0 px-3.5 sm:px-4 py-2 sm:py-2.5 rounded-lg 
            text-xs sm:text-sm font-medium transition-all duration-200 ease-in-out 
            focus:outline-none focus-visible:ring-2 focus-visible:ring-[#02B491] focus-visible:ring-offset-1
            whitespace-nowrap flex items-center justify-center group
            ${
              activeTab === tab.value
                ? 'bg-[#02B491] text-white shadow-md' // Active tab style from image
                : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800' // Inactive tab style
            }
          `}
        >
          <span className={`w-2 h-2 rounded-full mr-2 ${getDotColor(tab.label)} ${activeTab === tab.value ? 'opacity-75' : ''}`}></span>
          {tab.label}
          {typeof tab.count === 'number' && (
            <span 
              className={`ml-1.5 px-1.5 py-0.5 rounded-md text-xs font-semibold
                ${
                  activeTab === tab.value
                    ? 'bg-white/20 text-white' 
                    : 'bg-gray-200 text-gray-700 group-hover:bg-gray-300/70'
                }
              `}
            >
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

// Helper style to hide scrollbar if not already globally handled
const style = document.createElement('style');
style.innerHTML = `
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .no-scrollbar {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
`;
document.head.appendChild(style);

export default Tabs; 